import { createApp } from "vue";
import App from "./App.vue";

const app = createApp(App);
app.config.productionTip = false;

import router from "./router";
app.use(router);

//Componentes
import LoadingFull from "./components/LoadingFull.vue";
app.component("LoadingFull", LoadingFull);

// Axios
import axios from "axios";
import VueAxios from "vue-axios";
app.use(VueAxios, axios);

//Notificaciones
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
app.use(VueSweetalert2, {
   toast: false,
   timerProgressBar: true,
   theme: "dark",
});

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
const options = {
   transition: "Vue-Toastification__slideBlurred",
   maxToasts: 20,
   newestOnTop: true,
};
app.use(Toast, options);

import { createVfm } from "vue-final-modal";
import "vue-final-modal/style.css";
const vfm = createVfm();
app.use(vfm);

//Configuración de input money
app.config.globalProperties.$configMoney = {
   masked: false,
   prefix: "$",
   suffix: "",
   thousands: ".",
   decimal: ",",
   precision: 0,
   disableNegative: false,
   disabled: false,
   min: null,
   max: null,
   allowBlank: false,
   minimumNumberOfCharacters: 0,
   shouldRound: true,
   focusOnRight: false,
};

//Configuración para formato moneda
app.config.globalProperties.filters = {
   formatMoney(value) {
      return new Intl.NumberFormat("es-CO", {
         style: "currency",
         currency: "COP",
         maximumSignificantDigits: 21,
      }).format(value);
   },
};

//Vuedatepicker
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
app.component("VueDatePicker", VueDatePicker);

//URL de API
app.config.globalProperties.baseUrl = process.env.VUE_APP_API_URL;

app.mount("#app");
